// BooleanSelect.js
import { KrBadge } from '@/common/card/KrBadge';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const BooleanSelect = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, label, helperText, disabled, variant } = useFormFieldDef(fieldDef);
  const labelId = `${label}-label`;
  return (
    <FormControl fullWidth error={error} disabled={disabled} variant={variant}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value ?? ''} // Adjust default as needed for a boolean select
        onChange={(event) => setValue(event.target.value)}
        onBlur={onBlur}
        label={label}
      >
        <MenuItem value={true}>
          <KrBadge label="Yes" color="green" />
        </MenuItem>
        <MenuItem value={false}>
          <KrBadge label="No" color="gray" />
        </MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
